import CryptoJS from 'crypto-js';


const appName = process.env.REACT_APP_NAME

export function set (key:string, value:string, hashValue:boolean = false):boolean {

  const storageKey    = CryptoJS.MD5(`_${appName}-${key}`).toString()
  const storageValue  = hashValue ? CryptoJS.MD5(`${appName}-${value}`).toString() : value

  try {
    localStorage.setItem(storageKey, storageValue);
  } catch (error) {
    return false;
  }

  return true;
}

export function get (key:string) {
  const storageKey = CryptoJS.MD5(`_${appName}-${key}`).toString()
  return localStorage.getItem(storageKey) 
}

export function remove(key: string): boolean {
  const storageKey = CryptoJS.MD5(`_${appName}-${key}`).toString()
  try {
    localStorage.removeItem(storageKey)
  } catch (error) {
    return false
  }
  return true;
}

export function compare(key:string, externalValue:string) {
  const storageKey = CryptoJS.MD5(`_${appName}-${key}`).toString()
  const localValue = localStorage.getItem(storageKey)
  const securedExternalValue = CryptoJS.MD5(`${appName}-${externalValue}`).toString()

  if(localValue === securedExternalValue)
    return true
  else
    return false
}